const moment = require('moment');
const _require = require('expr-eval'),
  Parser = _require.Parser;
const _require2 = require('./constants'),
  maxSignificantDigits = _require2.maxSignificantDigits;
const _require3 = require('./common'),
  uuid = _require3.uuid;
const parser = new Parser();
const checkArray = array => {
  if (!Array.isArray(array)) {
    throw new Error('Argument should be array.');
  }
};
const checkLength = array => {
  checkArray(array);
  if (array.length === 0) {
    throw new Error('Array should not be empty.');
  }
};
const checkDefined = array => {
  checkLength(array);
  if (array.some(item => item === null || item === undefined)) {
    throw new Error('All arguments should be defined.');
  }
};
const checkNumbers = array => {
  checkDefined(array);
  if (array.some(item => Number.isNaN(item))) {
    throw new Error('All arguments should be numbers.');
  }
};
parser.functions.min = array => {
  checkNumbers(array);
  return Math.min(...array);
};
parser.functions.max = array => {
  checkNumbers(array);
  return Math.max(...array);
};
parser.functions.average = array => {
  checkNumbers(array);
  const result = array.reduce((sum, next) => sum + next, 0) / array.length;
  if (Number.isNaN(result)) {
    throw new Error('Invalid input to average() function.');
  }
  return Number.parseFloat(result.toFixed(maxSignificantDigits));
};
parser.functions.sum = array => {
  checkNumbers(array);
  const result = array.reduce((sum, next) => sum + next, 0);
  if (Number.isNaN(result)) {
    throw new Error('Invalid input to sum() function.');
  }
  return Number.parseFloat(result.toFixed(maxSignificantDigits));
};
parser.functions.count = array => {
  checkArray(array);
  const result = array.length;
  if (!array.every(item => item !== undefined)) {
    throw new Error('Invalid input to count() function.');
  }
  return result;
};
parser.functions.lastIndexOf = (item, array) => {
  checkArray(array);
  return array.lastIndexOf(item);
};
parser.functions.literalUndefined = () => undefined;
parser.functions.literalNull = () => null;
parser.functions.currentDate = () => moment().toISOString();
parser.functions.generateUUID = () => uuid();
module.exports = {
  parser
};